// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".success-body-title[data-v-47965441]{font-size:16px;font-family:\"Roboto\",sans-serif;font-weight:300;padding:0 2em;text-align:center}.success-reset-password-button span[data-v-47965441]{font-size:16px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
